import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Search from '../../components/Search'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FileGallery from '../FileGallery'
import styles from './FileGalleryModal.scss'

class FileGalleryModal extends Component {
  onKeyDown = (synthetic, event) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  onCancel = () => {
    this.props.toggle()
  }

  onSubmit = e => {
    e.preventDefault()

    this.props.toggle()
  }

  onSelect = (e, file) => {
    if (file.errorLoading) {
      alert('There was a problem loading the image, so we are refusing to embed it. Try replacing the image.')
      return
    }
    this.props.onSelect(e, file)
    this.props.toggle()
  }

  onSelectText = (file) => {
    return file.errorLoading
      ? '⚠️ '
      : 'Use'
  }

  render () {
    return (
      <Modal isOpen={this.props.isOpen} size='lg' toggle={this.props.toggle} className={styles.FileGalleryModal} zIndex={2000}>
        <ModalHeader toggle={this.props.toggle}>{this.props.filters && this.props.filters.type === 'image' ? 'Images' : 'Files'}</ModalHeader>
        <ModalBody onKeyDown={this.onKeyDown}>

          <Search value={this.props.searchValue} onSearchChange={this.props.onSearchChange} />
          <FileGallery
            match={this.props.match}
            history={this.props.history}
            onSelectText={this.onSelectText}
            filters={this.props.filters}
            limit={5}
            search={this.props.searchValue}
            onSelect={this.onSelect} />

          {false && <div className='debug-block'>
            state
            <pre>{JSON.stringify(this.state, null, 4)}</pre>
          </div>}

        </ModalBody>
        <ModalFooter>
          <Button form='FileGalleryForm' style={{display: 'none'}} type='submit' onClick={this.onSubmit}>Save</Button>{' '}
          <Button form='FileGalleryForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

FileGalleryModal.propTypes = {
  filters: PropTypes.object,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default FileGalleryModal



// WEBPACK FOOTER //
// ./src/components/FileGalleryModal/FileGalleryModalContainer.js